import { render, staticRenderFns } from "./Foldable.vue?vue&type=template&id=69b96565&scoped=true&"
import script from "./Foldable.vue?vue&type=script&lang=ts&"
export * from "./Foldable.vue?vue&type=script&lang=ts&"
import style0 from "./Foldable.vue?vue&type=style&index=0&id=69b96565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b96565",
  null
  
)

export default component.exports